import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ogFor } from "../lib/ogMeta";
import { coverFor } from "../lib/ogCovers";

const SITE = "https://crypt.pe";
const DEFAULT_TITLE = "Get paid in crypto. Share one link · crypt.pe";
const DEFAULT_DESC = "Accept ETH, USDC, USDT, BTC, SOL and more. Funds settle directly to your wallet. 0% fee. Available wherever wallet-to-wallet payments are permitted.";

function upsert(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Keeps og:* / twitter:* tags in sync with the current route so every page
// shares with a branded card. Crawlers that execute JS (Google, modern
// scrapers) pick these up; others fall back to the static default card.
export default function RouteOg() {
  const { pathname } = useLocation();

  useEffect(() => {
    const m = ogFor(pathname);
    const image = coverFor(pathname) || `${SITE}/og-home.png`;
    const title = m ? `${m.t} · crypt.pe` : DEFAULT_TITLE;
    const desc = m?.d || DEFAULT_DESC;

    upsert("property", "og:title", title);
    upsert("property", "og:description", desc);
    upsert("property", "og:url", `${SITE}${pathname === "/" ? "/" : pathname.replace(/\/+$/, "")}`);
    upsert("property", "og:image", image);
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", desc);
    upsert("name", "twitter:image", image);
  }, [pathname]);

  return null;
}
